document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
    var input = selector.querySelector('[data-quantity-input]');
    var minusBtn = selector.querySelector('[data-quantity-minus]');
    var plusBtn = selector.querySelector('[data-quantity-plus]');
    if (!input || !minusBtn || !plusBtn) return;

    function getMin() {
      var min = parseInt(input.getAttribute('min'), 10);
      return isNaN(min) ? 1 : min;
    }

    function updateDisabledState() {
      minusBtn.disabled = parseInt(input.value, 10) <= getMin();
    }

    minusBtn.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || getMin();
      var next = Math.max(getMin(), value - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateDisabledState();
    });

    plusBtn.addEventListener('click', function () {
      var value = parseInt(input.value, 10) || getMin();
      input.value = value + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateDisabledState();
    });

    input.addEventListener('change', function () {
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < getMin()) {
        input.value = getMin();
      }
      updateDisabledState();
    });

    updateDisabledState();
  });
});